// extracted by mini-css-extract-plugin
export default {"AvatarInput":"AvatarInput_AvatarInput__tVMQk","UploadLogButton":"AvatarInput_UploadLogButton__XosdI","HiddenInput":"AvatarInput_HiddenInput__o2dRf"};